import React, { useEffect } from "react";
import "./HealthTips.css";
import AOS from "aos";
import "aos/dist/aos.css";

const healthTips = [
  {
    title: "Manage Stress",
    desc: "Practice meditation, deep breathing, or hobbies to reduce stress levels.",
  },
  {
    title: "Maintain Hygiene",
    desc: "Wash hands frequently, maintain oral hygiene, and keep surroundings clean.",
  },
  {
    title: "Regular Health Checkups",
    desc: "Early detection is key! Schedule periodic doctor visits & screenings.",
  }
];

const HealthTips = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <div className="health-tips-page">
      <div className="tips-header">
        <p className="tips-small-title" data-aos="fade-down">
          STAY FIT & HEALTHY
        </p>

        <h2 data-aos="fade-up">Some Effective Health Tips</h2>

        <div className="tips-divider" data-aos="zoom-in">← ← ← ← ← ←</div>
      </div>

      <div className="tips-container">
        {healthTips.map((tip, index) => (
          <div
            className="tip-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
          >
            {tip.icon && (
              <img src={tip.icon} alt={tip.title} className="tip-icon" />
            )}

            <h3>{tip.title}</h3>
            <p>{tip.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthTips;
